<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      blank-header

    template(v-slot:default='props')

      #merchant-offer.view
        bf-wrapper.content.positioned.no-header
          .container.centered-text
            .logo.centered-text
              img( src='@/assets/logo.png' )
            bf-divider.borderless.card
            h1
              p {{ $t('BlueFaucet is') }}
              p {{ $t('beta-testing now') }}
            bf-divider.borderless.tight
            main
              .image.container
                img( src='@/assets/screen3.jpg' )
                bf-flex.centered.text-overlay.column
                  h1 {{ $t('To provide your service, continue signup as a Merchant') }}
              bf-divider.borderless.card
              a(
                ref='link'
                href='/onboarding/#slide2'
                v-show='false'
              )
              a.button(
                @click.prevent='join'
              )
                bf-button.large.wide.tall
                  template( v-slot:text ) {{ $t('SIGN UP AS MERCHANT') }}

</template>

<script>
  import { db } from '@/main'
  import BlankHeader from '@/components/blank-header'
  import { View, Animatable } from '@/mixins/view'

  export default {
    name: 'view.merchant-offer',

    mixins: [ View ],

    components: {
      BlankHeader
    },

    props: ['user', 'account'],

    methods: {
      join() {
        db.collection('accounts').doc(this.account.id).update({ merchant: true }).then( () =>
          this.$refs.link.click()
        )
      }
    }

  }

</script>

<style scoped lang='stylus'>

  .logo
    > img
      max-width 240px

  .text-overlay
    position absolute
    top 0
    right 0
    width 100%
    height 100%
    background rgba( 255 175 100 .75 )

  .image
    position relative
    height 216px
    img
      width 100%
      height 100%
      display block
      margin 0 auto
      object-fit cover

  .slider
    display flex
    box-sizing border-box
    .slide
      width 100%
      text-align center
      color white
      display flex
      flex-direction column

</style>
